import { render, staticRenderFns } from "./delivery-number-of-orders-cell.vue?vue&type=template&id=98a74e6e&scoped=true&"
import script from "./delivery-number-of-orders-cell.vue?vue&type=script&lang=js&"
export * from "./delivery-number-of-orders-cell.vue?vue&type=script&lang=js&"
import style0 from "./delivery-number-of-orders-cell.vue?vue&type=style&index=0&id=98a74e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a74e6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98a74e6e')) {
      api.createRecord('98a74e6e', component.options)
    } else {
      api.reload('98a74e6e', component.options)
    }
    module.hot.accept("./delivery-number-of-orders-cell.vue?vue&type=template&id=98a74e6e&scoped=true&", function () {
      api.rerender('98a74e6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/additions/delivery-number-of-orders-cell.vue"
export default component.exports